document.addEventListener("DOMContentLoaded", (event) => {
  window.addEventListener('scroll', function() {
    const floatingDiv = document.querySelector('.product-info_action_inner');
    const parentDiv = floatingDiv.parentElement; // Obtén el div padre

    const scrollY = window.scrollY || window.pageYOffset;

    // Calcula la posición máxima en la que el div flotante puede moverse
    const parentRect = parentDiv.getBoundingClientRect();
    const floatingRect = floatingDiv.getBoundingClientRect();
    const maxScroll = parentRect.height - floatingRect.height;
    
    // Ajusta la posición del div flotante
    if (scrollY <= maxScroll) {
        floatingDiv.style.top = `${scrollY + 10}px`;
    } else {
        floatingDiv.style.top = `${maxScroll}px`;
    }
  });
});

